import { BrowserRouter, Route, Routes } from 'react-router';

import { Layout } from '@/components/layout/Layout';
import { AboutPage } from '@/pages/AboutPage';
import { BlogPage } from '@/pages/BlogPage';
import { EpisodePage } from '@/pages/EpisodePage';
import { HomePage } from '@/pages/HomePage';
import { NotFoundPage } from '@/pages/NotFoundPage';
import { SeriePage } from '@/pages/SeriePage';

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="blog" element={<BlogPage />} />
          <Route path="serie" element={<SeriePage />} />
          <Route path="serie/:slug" element={<EpisodePage />} />
          <Route path="a-propos" element={<AboutPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
